module.exports = __webpack_public_path__ + "static/img/2_2_2.917d9fd0.jpg";